export default "__VITE_ASSET__80747d29__"